<template>
  <div>
    <div>
      <Multiselect
        class="form-control"
        :class="isInvalid ? 'is-invalid' : ''"
        v-model="selectedValue"
        :close-on-select="true"
        :searchable="false"
        :options="maintainOptions"
        :placeholder="$t('page.select-maintenance-name')"
        @change="handleChange"
      />
    </div>
    <div class="mt-1" v-if="showTipsWhenErr && isInvalid"><span class="text-danger">{{ $t('page.maintenance-name-required') }}</span></div>
  </div>
</template>
<script>
import { ref, watchEffect } from 'vue'
import { maintenanceItemList } from '@/utils/selectText'

const parsedMaintainOptions = maintenanceItemList.map(item => {
  return {
    value: item.value,
    label: item.label
  }
})

export default {
  // 维护保养项目选择
  props: {
    value: {
      type: [String, Number],
      default: null
    },
    isInvalid: {
      type: Boolean,
      default: false,
    },
    showTipsWhenErr: {
      type: Boolean,
      default: false
    }
  },
  setup(props, { emit } ) {
    const selectedValue = ref(props.value)
    const maintainOptions = ref(parsedMaintainOptions)

    watchEffect(() => {
      selectedValue.value = props.value
    })

    const handleChange = (value) => {
      selectedValue.value = value
      // 通知父组件
      emit('update:value', value)
      emit('changed', value)
    }

    return {
      selectedValue,
      maintainOptions,
      handleChange,
    }
  }
}
</script>

